import { render } from "./setCardsForClient.vue?vue&type=template&id=3838a346&scoped=true"
import script from "./setCardsForClient.vue?vue&type=script&lang=js"
export * from "./setCardsForClient.vue?vue&type=script&lang=js"

import "./setCardsForClient.vue?vue&type=style&index=0&id=3838a346&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3838a346"]])

export default __exports__